import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	faq: {
		id: 'partner.account.faq.short',
		defaultMessage: 'For more information, <faqtext>read our FAQ</faqtext>.',
		description: 'Account faq',
	},
	personalEmail: {
		id: 'partner.account.personalEmail',
		defaultMessage: 'Use your personal email address so you can take your Calm account with you.',
		description: 'Account personal email prompt',
	},
	continuedAccess: {
		id: 'partner.account.continuedAccess',
		defaultMessage: 'Use a personal email address to ensure continued access to your account.',
		description:
			'Prompt the user to use a personal email so they will never lose access to their Calm account',
	},
	valuePropHeader: {
		id: 'partner.b2b.account.valueproplist.header',
		defaultMessage: 'Feeling better can become a habit.',
		description: 'Value props of calm on the account screen',
	},
	valueProp1Head: {
		id: 'partner.b2b.account.valueprop1.header',
		defaultMessage: 'Get relief from stress and anxiety',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp1Body: {
		id: 'partner.b2b.account.valueprop1.body',
		defaultMessage: 'Explore sessions and exercises led by experts to quickly calm your mind',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp2Head: {
		id: 'partner.b2b.account.valueprop2.header',
		defaultMessage: 'Fall (and stay) asleep naturally',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp2Body: {
		id: 'partner.b2b.account.valueprop2.body',
		defaultMessage: 'Enjoy Sleep Stories and meditations to keep you relaxed through the night',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp3Head: {
		id: 'partner.b2b.account.valueprop3.header',
		defaultMessage: 'Learn from the best',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	valueProp3Body: {
		id: 'partner.b2b.account.valueprop3.body',
		defaultMessage: 'Our instructors make mindfulness easy and welcoming, even for beginners',
		description: 'Value Proposition to the user of benefits of Calm',
	},
	headingSignup: {
		id: 'partner.b2b.account.heading.signup',
		defaultMessage: 'Sign up today at no additional cost as part of your benefits.',
		description: 'Account heading for Sign up',
	},
	headingLogin: {
		id: 'partner.b2b.account.heading.login',
		defaultMessage: 'Log into your account to claim your benefit',
		description: 'Account heading for Log in',
	},
	recImage: {
		id: 'valueProps.recImage',
		defaultMessage: 'Recommended content image',
		description: 'alt text for recommended content image',
	},
});
